import { default as React, useContext } from "react";


import { WithTranslation, withTranslation } from "react-i18next";
import Row from "./row";
import { SpanningDefaultFBPDto } from "core/backend/data";

interface OwnProps {
    scrollPosition?: { left: number, top: number };
    data: SpanningDefaultFBPDto[];
}

const List = ({ t, data, scrollPosition }: OwnProps & WithTranslation) => {
    const top = Math.max(0, ((scrollPosition?.top || 0) - 16));
    const left = Math.max(0, ((scrollPosition?.left || 0) - 16));

    return (
        <table id="datatable">
            <thead>
                <tr>
                    <th className="fixedDateColumn" style={{ top: top + "px", left: left + "px" }}>{t("common:Date")}</th>
                    <th className="fixedHeader" style={{ top: top + "px" }}>{t("page_spanningDefaultFBP:computation")}</th>
                    <th className="fixedHeader" style={{ top: top + "px" }}>{t("page_spanningDefaultFBP:type")}</th>
                </tr>
            </thead>
            <tbody>
                {
                    data && data.map((d) => <Row key={d.id} dto={d} left={left} />)
                }
            </tbody>
        </table>
    );
};

const translated = withTranslation("page_spanningDefaultFBP")(List);

export default translated;